export default "__VITE_ASSET__CA0ZSz2___"